







































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import TipJarModal from '@/web/components/settings/TipJarModal.vue';
import StudioSocial from '@/web/components/navigation/StudioSocial.vue';
import CompactEventsCalendarModal from '@/web/components/events/CompactEventsCalendarModal.vue';

export default Vue.extend({
  name: 'StudentMarvelousBio',
  components: {
    StudioSocial,
  },
  computed: {
    ...mapGetters({
      currentStudio: 'studio/currentStudio',
      currency: 'studio/currency',
    }),
    backgroundImageURL() {
      return (
        this.marvelousBio?.image?.storage_url ??
        this.marvelousBio?.image?.embedded_image_url
      );
    },
    bioLinks() {
      return this.marvelousBio?.bio_links;
    },
  },
  methods: {
    openTipModal() {
      this.$modal.show(TipJarModal, {
        studioName: this.currentStudio.studio_name,
        currency: this.currency,
      });
    },
    openCalendarModal() {
      this.$modal.show(
        CompactEventsCalendarModal,
        {
          studioURL: this.currentStudio.studio_url,
          openInNewWindow: true,
        },
        {
          classes: ['compact-calendar-modal'],
        }
      );
    },
    sortPosition(items) {
      this.sortedLinks = items.sort((a, b) => a.position - b.position);
    },
  },
  data() {
    return {
      marvelousBio: null,
      sortedLinks: [],
    };
  },
  async mounted() {
    this.marvelousBio = await this.$store.dispatch(
      'studio/getMarvelousBio',
      getStudioURL(this.$route)
    );
  },
  watch: {
    bioLinks: {
      handler(value) {
        this.sortPosition([...this.bioLinks]);
      },
    },
  },
});
